import * as React from 'react';
import { TaskBoardCard } from '@progress/kendo-react-taskboard';
import { CardBody } from '@progress/kendo-react-layout';

/* gemeinsamer Style für alle Info-Zeilen */
const infoStyle = {
  fontSize: '0.8rem',
  margin: '2px 0'
};

/* ---------- Header (Firma) ---------- */
const CardHeaderComponent = ({ task }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <span style={{ fontWeight: 'bold', color: '#f5811e' }}>
      {task.title || 'Unbekannter Kunde'}
    </span>
  </div>
);

/* ---------- Body (Adresse + Person) ---------- */
const CardBodyComponent = ({ task }) => (
  <CardBody style={{ padding: 4 }}>
    <p style={infoStyle}>
      <strong>Straße:</strong> {task.street || '–'}
    </p>
    <p style={infoStyle}>
      <strong>Ort:</strong> {task.city || '–'}
    </p>
    <p style={infoStyle}>
      <strong>Vorname:</strong> {task.firstName || '–'}
    </p>
    <p style={infoStyle}>
      <strong>Nachname:</strong> {task.lastName || '–'}
    </p>
  </CardBody>
);

export const Card = (props) => (
  <TaskBoardCard
    {...props}                           /* ← Drag-&-Drop Props bleiben erhalten */
    style={{ padding: 5, ...props.style }}
    cardHeader={CardHeaderComponent}
    cardBody={CardBodyComponent}
  />
);
